// hooks/useAuthState.js
import { useAuth } from '../contexts/AuthContext'

export function useAuthState () {
  const { user, loading, error } = useAuth()

  // Check if userData is still loading (user exists but userData is undefined)
  const isUserDataLoading = user && user.userData === undefined

  const userRole = user?.userData?.role || 'user'
  const isUser = userRole === 'user'
  const isModerator = userRole === 'moderator'
  const isAdmin = userRole === 'admin'
  const isSuperAdmin = userRole === 'superadmin'

  // Moderatoren, Admins und SuperAdmins können Knowledge moderieren
  const hasModeratorAccess = isModerator || isAdmin || isSuperAdmin

  // Nur Admins und SuperAdmins haben vollen Admin-Zugriff
  const hasAdminAccess = isAdmin || isSuperAdmin

  return {
    user,
    loading: loading || isUserDataLoading, // Also loading if userData is not yet loaded
    error,
    isAuthenticated: !!user,
    userRole,
    isUser,
    isModerator,
    isAdmin,
    isSuperAdmin,
    hasModeratorAccess,
    hasAdminAccess,
    company: user?.userData?.company || '',
    companyId: user?.userData?.companyId || null
  }
}
